/**
 * Canonical product order — the SINGLE source of truth for the sequence of
 * products across the app. The left-nav (AppRail) and the home product grid
 * (homeProducts) both derive their order from this list, so they can never
 * silently drift apart again.
 *
 * To reorder a product anywhere it appears: edit this array. Nowhere else.
 */
export const PRODUCT_ORDER = [
  "/career-transition",
  "/agentic-ai-mastery",
  "/agentic-ops",
  "/portfolio-kit",
  "/resume-mastery",
  "/agentic-interviewing",
  "/linkedin-presence",
  "/forge-coach", // nav-only — not a home grid chip
  "/coach",
  "/visibility-strategy",
  "/claude-harness",
] as const;

export type ProductPath = (typeof PRODUCT_ORDER)[number];

/**
 * Canonical public product names shared by product navigation and product
 * discovery surfaces. Keep public product naming aligned by importing this
 * value instead of introducing a competing label.
 */
export const PRODUCT_NAMES = {
  agenticAiInterviewing: "Agentic AI Interviewing",
} as const;

/** Paths that appear in the home grid: everything except the nav-only Forge Coach. */
export type HomeProductPath = Exclude<ProductPath, "/forge-coach">;

/** Home grid order = canonical order minus Forge Coach. */
export const HOME_PRODUCT_ORDER: readonly HomeProductPath[] = PRODUCT_ORDER.filter(
  (path): path is HomeProductPath => path !== "/forge-coach",
);
